import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import About from "./components/About/About";
import Header from "./components/Header/Header";
import SuperHero from "./components/SuperHero/SuperHero";
import { Circle2 } from "react-preloaders2";
import Projects from "./components/Projects/Projects";
import ContactMe from "./components/ContactMe/ContactMe";
import FAQ from "./components/FAQ/FAQ";
import Footer from "./components/Footer/Footer";
import AllProjects from "./components/AllProjects/AllProjects";
import AllFAQs from "./components/AllFAQs/AllFAQs";

const App = () => {
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path="/">
          <SuperHero />
          <About />
          <Projects />
          <ContactMe />
          <FAQ />
          <Footer />
        </Route>
        <Route exact path="/about">
          <About />
        </Route>
        <Route exact path="/allprojects">
          <AllProjects />
        </Route>
        <Route exact path="/projects">
          <Projects />
        </Route>
        <Route exact path="/contact">
          <ContactMe />
        </Route>
        <Route exact path="/allfaqs">
          <AllFAQs />
        </Route>
      </Switch>
      <Circle2 color={"#007fff"} />
    </Router>
  );
};

export default App;
